import { Pipe, PipeTransform } from '@angular/core';
import { FacilityItemInformation } from '../common/models/facilityItemInformation';

@Pipe({
  name: 'leadMinutesFormat',
  standalone: true,
})
export class LeadMinutesFormatPipe implements PipeTransform {
  public transform(value: number): string {
    if (value) {
      if (value >= 60) {
        return value % 60 > 0 ? (value / 60).toFixed(2) + ' hr.' : value / 60 + ' hr.';
      } else {
        return value + ' min.';
      }
    } else {
      return '0 hr.';
    }
  }
}

@Pipe({
  name: 'prepMinutesFormat',
  standalone: true,
})
export class PrepMinutesFormatPipe implements PipeTransform {
  public transform(value: number): string {
    return value ? value + ' min.' : '';
  }
}
